/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CompanyCreation, CompanyInfo } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class CompaniesClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags Companies
   * @summary Получение списка идентификаторов ДО
   * @request GET:/geology/Companies
   * @secure
   */
  companiesGetCompanyIds = (params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/geology/Companies`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Companies
   * @summary Создаёт компании.
   * @request POST:/geology/Companies
   * @secure
   */
  companiesCreateCompanies = (data: CompanyCreation[], params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/geology/Companies`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Companies
   * @summary Получение информации о всех ДО
   * @request GET:/geology/Companies/all-data
   * @secure
   */
  companiesGetAllCompaniesData = (params: RequestParams = {}) =>
    this.http.request<CompanyInfo[], any>({
      path: `/geology/Companies/all-data`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Companies
   * @summary Получение информации о ДО по идентификатору
   * @request GET:/geology/Companies/{companyId}
   * @secure
   */
  companiesGetCompanyDetails = (companyId: string, params: RequestParams = {}) =>
    this.http.request<CompanyInfo, any>({
      path: `/geology/Companies/${companyId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
}
